import { useMemo } from 'react';
import { NavConfigProps } from './types';

// ----------------------------------------------------------------------

export const useNavVerticalConfig = (config?: NavConfigProps) =>
  useMemo(
    () => ({
      itemGap: config?.itemGap || 3,
      iconSize: config?.iconSize || 24,
      currentRole: config?.currentRole,
      itemRootHeight: config?.itemRootHeight || 40,
      itemSubHeight: config?.itemSubHeight || 34,
      itemPadding: config?.itemPadding || '3px 6px 3px 10px',
      itemRadius: config?.itemRadius || 8,
      hiddenLabel: config?.hiddenLabel || false,
    }),
    [config]
  );

export const useNavMiniConfig = (config?: NavConfigProps) =>
  useMemo(
    () => ({
      itemGap: config?.itemGap || 4,
      iconSize: config?.iconSize || 22,
      currentRole: config?.currentRole,
      itemRootHeight: config?.itemRootHeight || 56,
      itemSubHeight: config?.itemSubHeight || 34,
      itemPadding: config?.itemPadding || '6px 0 0 0',
      itemRadius: config?.itemRadius || 6,
      hiddenLabel: config?.hiddenLabel || false,
    }),
    [config]
  );

export const useNavHorizontalConfig = (config?: NavConfigProps) =>
  useMemo(
    () => ({
      itemGap: config?.itemGap || 6,
      iconSize: config?.iconSize || 22,
      currentRole: config?.currentRole,
      itemRootHeight: config?.itemRootHeight || 32,
      itemSubHeight: config?.itemSubHeight || 34,
      itemPadding: config?.itemPadding || '0 6px 0 6px',
      itemRadius: config?.itemRadius || 6,
      hiddenLabel: config?.hiddenLabel || false,
    }),
    [config]
  );

// Legacy functions for backward compatibility
export const navVerticalConfig = (config?: NavConfigProps) => ({
  itemGap: config?.itemGap || 3,
  iconSize: config?.iconSize || 24,
  currentRole: config?.currentRole,
  itemRootHeight: config?.itemRootHeight || 40,
  itemSubHeight: config?.itemSubHeight || 34,
  itemPadding: config?.itemPadding || '3px 6px 3px 10px',
  itemRadius: config?.itemRadius || 8,
  hiddenLabel: config?.hiddenLabel || false,
});

export const navMiniConfig = (config?: NavConfigProps) => ({
  itemGap: config?.itemGap || 4,
  iconSize: config?.iconSize || 22,
  currentRole: config?.currentRole,
  itemRootHeight: config?.itemRootHeight || 56,
  itemSubHeight: config?.itemSubHeight || 34,
  itemPadding: config?.itemPadding || '6px 0 0 0',
  itemRadius: config?.itemRadius || 6,
  hiddenLabel: config?.hiddenLabel || false,
});

export const navHorizontalConfig = (config?: NavConfigProps) => ({
  itemGap: config?.itemGap || 6,
  iconSize: config?.iconSize || 22,
  currentRole: config?.currentRole,
  itemRootHeight: config?.itemRootHeight || 32,
  itemSubHeight: config?.itemSubHeight || 34,
  itemPadding: config?.itemPadding || '0 6px 0 6px',
  itemRadius: config?.itemRadius || 6,
  hiddenLabel: config?.hiddenLabel || false,
});
